export default __webpack_public_path__ + "static/media/plateIcon.d0e6ceb3.svg";